import { z } from 'zod';
import { paginationSchema } from '../../../shared/index.js';
export const meetingBodyVacantSeatSearchSchema = paginationSchema.extend({
    meetingBodyId: z.number('Meeting body ID must be a number').optional(),
    meetingBodyCategoryId: z.number('Meeting body category ID must be a number').optional(),
});
// Form schema without pagination parameters for react-hook-form
export const meetingBodyVacantSeatFilterFormSchema = meetingBodyVacantSeatSearchSchema.pick({
    meetingBodyId: true,
    meetingBodyCategoryId: true,
});
